module.exports = __webpack_public_path__ + "img/Young_frege.512b8e48.jpg";